module.exports = __webpack_public_path__ + "img/blank-comic-book_B098GT2SFB.dc8a3db7.jpg";